import { contentRegistry } from './buildContentRegistry';
export const getCollectionById = (id) => contentRegistry.collectionsById.get(id);
//# sourceMappingURL=getCollectionById.js.map